import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router/dom';
import '@/styles/app.css';
import { Providers } from '@/app/Providers';
import { createAppRouter } from '@/app/router';
import { installChunkReload } from '@/lib/chunkReload';
import { initPriceFeed } from '@/realtime/hub';

// Before the router starts loading route chunks, so a stale chunk after a deploy reloads the page once.
installChunkReload();
// Follows the session: connects after sign-in, stops at sign-out.
initPriceFeed();

const router = createAppRouter();
const root = document.getElementById('root');

if (!root) throw new Error('index.html has no #root element');

createRoot(root).render(
  <StrictMode>
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  </StrictMode>,
);
